import { css } from '@emotion/react';

export default ($) => {
  return css`
    h1, h2, h3, h4, h5, h6,
    .h1, .h2, .h3, .h4, .h5, .h6 {
      margin-bottom: ${$.headingsMarginBottom};
      font-family: ${$.headingsFontFamily};
      font-weight: ${$.headingsFontWeight};
      line-height: ${$.headingsLineHeight};
      color: ${$.headingsColor};
    }

    h1, .h1 { font-size: ${$.h1FontSize}; }
    h2, .h2 { font-size: ${$.h2FontSize}; }
    h3, .h3 { font-size: ${$.h3FontSize}; }
    h4, .h4 { font-size: ${$.h4FontSize}; }
    h5, .h5 { font-size: ${$.h5FontSize}; }
    h6, .h6 { font-size: ${$.h6FontSize}; }

    .lead {
      font-size: ${$.leadFontSize};
      font-weight: ${$.leadFontWeight};
    }

    .display-1 {
      font-size: ${$.display1Size};
      font-weight: ${$.display1Weight};
      line-height: ${$.displayLineHeight};
    }
    .display-2 {
      font-size: ${$.display2Size};
      font-weight: ${$.display2Weight};
      line-height: ${$.displayLineHeight};
    }
    .display-3 {
      font-size: ${$.display3Size};
      font-weight: ${$.display3Weight};
      line-height: ${$.displayLineHeight};
    }
    .display-4 {
      font-size: ${$.display4Size};
      font-weight: ${$.display4Weight};
      line-height: ${$.displayLineHeight};
    }

    hr {
      margin-top: ${$.hrMarginY};
      margin-bottom: ${$.hrMarginY};
      border: 0;
      border-top: ${$.hrBorderWidth} solid ${$.hrBorderColor};
    }

    small,
    .small {
      font-size: ${$.smallFontSize};
      font-weight: ${$.fontWeightNormal};
    }

    mark,
    .mark {
      padding: ${$.markPadding};
      background-color: ${$.markBg};
    }

    .list-unstyled {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .list-inline {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    .list-inline-item {
      display: inline-block;

      &:not(:last-child) {
        margin-right: ${$.listInlinePadding};
      }
    }

    .initialism {
      font-size: 90%;
      text-transform: uppercase;
    }

    .blockquote {
      margin-bottom: ${$.spacer};
      font-size: ${$.blockquoteFontSize};
    }

    .blockquote-footer {
      display: block;
      font-size: ${$.blockquoteSmallFontSize};
      color: ${$.blockquoteSmallColor};

      &::before {
        content: "\\2014\\00A0"; // em dash, nbsp
      }
    }
  `;
}